var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.724 6.65a.72.72 0 0 0-.7.73v6.2c0 .411.327.73.7.73h8.49a.72.72 0 0 0 .7-.73v-6.2a.72.72 0 0 0-.7-.73zM2 7.38c0-.955.764-1.753 1.724-1.753h8.49c.96 0 1.724.798 1.724 1.752v6.202c0 .954-.764 1.752-1.724 1.752h-8.49c-.96 0-1.724-.798-1.724-1.752zm5.969-5.69c-1.405 0-2.52 1.124-2.52 2.588a.512.512 0 0 1-1.023 0C4.426 2.27 5.978.666 7.969.666s3.543 1.604 3.543 3.612a.512.512 0 0 1-1.023 0c0-1.464-1.116-2.589-2.52-2.589",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11 3.767c.283 0 .512.229.512.511v1.613a.512.512 0 0 1-1.023 0V4.278c0-.282.23-.511.512-.511m-6.064 0c.283 0 .512.229.512.511v1.799a.512.512 0 0 1-1.023 0V4.278c0-.282.229-.511.511-.511",
  clipRule: "evenodd"
})));
export default SvgLock;